const brandsModules = document.querySelectorAll('.brands-module');

const calcSectionHeaderHeight = (element) => {
  const parent = element.closest('.brands-module');
  if (parent) {
    const headerHeight = element.offsetHeight;
    parent.style.setProperty('--header-height', `${headerHeight}px`);
  }
};

brandsModules.forEach((el) => {
  const stickyFaker = el.querySelector('.brands-module__faker-body');
  const stickyLogoFaker = el.querySelector('.brands-module__faker-parent-logo');
  const stickyDividerFaker = el.querySelector('.brands-module__faker-divider');
  const stickyPartnersFaker = el.querySelector('.brands-module__faker-partners');
  const stickyPart = el.querySelector('.brands-module__body');
  const stickyLogoPart = el.querySelector('.brands-module__logo');
  const stickyDividerPart = el.querySelector('.brands-module__divider');
  const stickyPartnersPart = el.querySelector('.brands-module__partners');
  const sectionHeader = el.querySelector('.section-header');

  calcSectionHeaderHeight(sectionHeader);
  window.addEventListener('resize', calcSectionHeaderHeight(sectionHeader));

  let controllerBrandsModule = null;
  controllerBrandsModule = new ScrollMagic.Controller();

  // ----
  // Body Sticky scene
  // ----
  const initBodyStickyScene = () => {
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyFaker,
      duration: stickyFaker.offsetHeight,
      triggerHook: 0,
    })
      .setPin(stickyPart)
      .addTo(controllerBrandsModule);

    if (isLocal()) {
      scene.addIndicators({ name: 'Section Sticky' });
    }
  };

  // ----
  // Parent Logo Sticky scene
  // ----
  const initLogoStickyScene = () => {
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyLogoFaker,
      duration: stickyLogoFaker.offsetHeight,
      triggerHook: 0,
    })
      .setPin(stickyLogoPart)
      .addTo(controllerBrandsModule);

    if (isLocal()) {
      scene.addIndicators({ name: 'Parent Logo Sticky' });
    }
  };

  // ----
  // Divider Sticky scene
  // ----
  const initDividerStickyScene = () => {
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyDividerFaker,
      duration: stickyDividerFaker.offsetHeight,
      triggerHook: 0,
    })
      .setPin(stickyDividerPart)
      .addTo(controllerBrandsModule);

    if (isLocal()) {
      scene.addIndicators({ name: 'Divider Sticky' });
    }
  };

  // ----
  // Partners Sticky scene
  // ----
  const initPartnersStickyScene = () => {
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyPartnersFaker,
      duration: stickyPartnersFaker.offsetHeight,
      triggerHook: 0,
    })
      .setPin(stickyPartnersPart)
      .addTo(controllerBrandsModule);

    if (isLocal()) {
      scene.addIndicators({ name: 'Partners Sticky' });
    }
  };

  // ----
  // Init All scene
  // ----
  const initAllScenes = () => {
    initBodyStickyScene();
    initLogoStickyScene();
    initDividerStickyScene();
    initPartnersStickyScene();
  };

  // ----
  // Destroy for mobile
  // ----
  const handleResize = () => {
    initializeOrDestroyScrollMagic(controllerBrandsModule, initAllScenes);
  };

  if (windowWidth() >= breakpointSm) {
    initAllScenes();
  }

  window.addEventListener('resize', handleResize);
});
